import { Injectable, NgModule } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Observable } from 'rxjs';


@Injectable()
export class HttpsRequestInterceptor implements HttpInterceptor {
    constructor() { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token = localStorage.getItem('session_id')
        if (token) {
            request = request.clone({
                setHeaders: { 
                    // 'access-type': 'c4975b3e-fc1c-4d83-b5d2-676cee132574',
                    // 'Authorization': 'Basic ' + btoa(token + ':')
                    // 'Content-type': 'application/x-www-form-urlencoded',
                }
            });
        }

        return next.handle(request);
    }
}
@NgModule({
    imports: [],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: HttpsRequestInterceptor, multi: true }
    ]
})
export class HeaderInterceptorModule { }

// // rxjs

// import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HTTP_INTERCEPTORS } from "@angular/common/http";
// import { Injectable, NgModule } from "@angular/core";
// import { Observable } from "rxjs";

// /** 
//  * @type {Array<string>} - list of routes without token request
//  */
// const IGNORED_URLS = ['/u/auth/login', 'https://onesignal.com/api/v1/notifications']


// @Injectable()
// export class HttpsRequestInterceptor implements HttpInterceptor {
//     constructor(private storage: Storage) { }
//     intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
//         // STORE TOKEN IN STORAGE (if applicable) TO SET AUTHORIZATION HEADER BY DEFAULT
//         return fromPromise(this.storage.get('token')).pipe(switchMap(token => { //
//             if (!IGNORED_URLS.includes(req.url)) {
//                 const headers = new HttpHeaders({
//                     Authorization: `Bearer ${token}`,
//                     // 'Content-Type': 'application/json' // uncomment if needed
//                 })
//                 const dupReq = req.clone({ headers });
//                 return next.handle(dupReq);
//             } else {
//                 return next.handle(req)
//             }
//         }))
//     }
// };
// @NgModule({
//     imports: [],
//     providers: [
//         { provide: HTTP_INTERCEPTORS, useClass: HttpsRequestInterceptor, multi: true }
//     ]
// })
// export class HeaderInterceptorModule { }

// // if the backend used sql you convert the response, use this instead:
// /*
// return fromPromise(this.storage.get('token')).pipe(switchMap(token => {
//             const headers = new HttpHeaders({
//                 Authorization: `Bearer ${token}`
//             })
//             const dupReq = req.clone({ headers });
//             return next.handle(dupReq).map((event: HttpEvent<any>) => {
//                 if (event instanceof HttpResponse) {
//                     if (event.body.data) {       // If event body response has data returned
//                         return event.clone({
//                             body: {...event.body, data: this.objConverter.convertResponse(event.body.data)} // Convert the response into a valid and well formatted object globally if response body data exist
//                         })
//                     }
//                 }
//                 return event;
//               })
// }))
// */
